import { AutheticationAssistant } from "./AssistantSections/AutheticationAssistant";
import { CalendarAssistant } from "./AssistantSections/CalendarAssistant";
import { DashboardAssistant } from "./AssistantSections/DashboardAssistant";
import { FacilitiesAssistant } from "./AssistantSections/FacilitiesAssistant";
import { FormsAssistant } from "./AssistantSections/FormsAssistant";
import { LogsAssistant } from "./AssistantSections/LogsAssistant";
import { MessageAssistant } from "./AssistantSections/MessageAssistant";
import { PatientProfilesAssistant } from "./AssistantSections/PatientProfilesAssistant";
import { QuestionnairesAssistant } from "./AssistantSections/QuestionnairesAssistant";
import { ToDoListAssistant } from "./AssistantSections/ToDoListAssistant";
import { UIAssistant } from "./AssistantSections/UIAssistant";
import { UsersAssistant } from "./AssistantSections/UsersAssistant";
import { WorkFlowAssistant } from "./AssistantSections/WorkFlowAssistant";
/**
 * Permission Types : 'Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'
 * 'Clinician', 
 * 'Clinical User', 
 * 'Admin', 
 * 'Office Admin',
 *  'System Admin',
 *  'DrData Tech', 
 * 'DrData Sales', 
 * 'DrData Compliance', 
 * 'Patient', 
 * 'Client', 
 * 'Super', 
 * 'Facility Manager', 
 * 'Technical Support', 
 * 'System Admin', 
 * 'DrData Tech', 
 * 'DrData Sales', 
 * 'DrData Compliance'
 * 
 * Template:
 *   {
                heading: 'Viewing your to do list items',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['to do list', 'to do list screen', 'todolist', 'todo list', 'todo list screen', 'to do', 'todo'],
                sections: [
                    {
                        description: 'Your to do list items are shown on the main to do list screen',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListSelection',
                            action: 'highlight'
                        }
                    },
                ],
                options: [
                    {
                        option: 'Take me to the main to do list screen',
                        action: {
                            type: 'location',
                            value: '/Dashboard/ToDo',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
 * 
 */

export const OnScreenHelpItems = {
    ...AutheticationAssistant,
    ...CalendarAssistant,
    ...DashboardAssistant,
    ...FacilitiesAssistant,
    ...FormsAssistant,
    ...LogsAssistant,
    ...MessageAssistant,
    ...PatientProfilesAssistant,
    ...ToDoListAssistant,
    ...QuestionnairesAssistant,
    ...UsersAssistant,
    ...UIAssistant,
    ...WorkFlowAssistant,
    // "Dashboard": {
    //     items: [{
    //         heading: 'Doing general things',
    //         description: 'test this',
    //         permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
    //         tags: ['dashboard'],
    //         sections: [
    //             {
    //                 description: 'Your to do list items are shown on the main to do list screen',
    //                 styleAs: 'list',
    //                 ref: {
    //                     ref: 'ToDoListSelection',
    //                     action: 'highlight'
    //                 }
    //             },
    //         ],
    //         options: [
    //             {
    //                 option: 'Take me to the main to do list screen',
    //                 action: {
    //                     type: 'location',
    //                     value: '/Dashboard/ToDo',
    //                     params: { section: 'main' }
    //                 },

    //             },
    //         ]
    //     },
    //     ]
    // }
}